import { collection, doc, setDoc, getDocs } from "firebase/firestore";
import { db } from "../../firebase/config";
import { newEventId } from "../../domain/cmoe/events/eventTypes";

function matchEventRef(competitionId, matchId, eventId) {
  return doc(db, "competitions", competitionId, "matches", matchId, "events", eventId);
}

function matchEventsCol(competitionId, matchId) {
  return collection(db, "competitions", competitionId, "matches", matchId, "events");
}

/**
 * @param {string} competitionId
 * @param {string} matchId
 */
export async function listMatchOrchestrationEvents(competitionId, matchId) {
  const snap = await getDocs(matchEventsCol(competitionId, matchId));
  return snap.docs.map((d) => d.data());
}

/**
 * @param {string} competitionId
 * @param {string} matchId
 * @param {import('../../domain/cmoe/events/eventTypes').OrchestrationEvent} event
 */
export async function appendMatchOrchestrationEvent(competitionId, matchId, event) {
  const eventId = event.eventId || newEventId();
  await setDoc(matchEventRef(competitionId, matchId, eventId), {
    ...event,
    eventId,
    aggregateType: "match",
    aggregateId: matchId,
  });
}
